import { Helmet } from 'react-helmet';
import { getRequestContext } from '@/shared/lib/requestContext';

const DEFAULT_TITLE = 'Оформление заказа';

export const Meta = () => {
    const {
        company: { companyTitle },
    } = getRequestContext();

    return <Helmet>{companyTitle ? <title>{companyTitle}</title> : <title>{DEFAULT_TITLE}</title>}</Helmet>;
};
